export default class WindowSize {
    static isMobile() {
        return this.checkSize(768);
    }

    static checkSize(size: number) {
        return window.innerWidth < size;
    }
}
